import { pricingPartnerAction } from "./PricingPartnerDetailsAction";

const initialState = {
  loading: false,
  partnerDetail: [],
  error: "",
};

const pricingPartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case pricingPartnerAction.PARTNER_DATA_SUCCESS:
      return {
        ...state,
        partnerDetail: action.payload,
      };

    default:
      return {
        state,
      };
  }
};

export default pricingPartnerReducer;
